import { useNavigate } from "react-router-dom";
import { TypedUseNavigateFunction } from "../mz/router/hooks/useTypedNavigate";
import { RoutePath } from "../pages/RoutePath";

export const useAppNavigate = useNavigate as TypedUseNavigateFunction<RoutePath>;
